import { useTranslation } from "react-i18next";
import { PageContentBox, AppPageContentWrapper } from "@duosoftbg/nacid-components";
import ARUniEntryRequestEdit from "../../../../components/registers/request/arUni/ARUniEntryRequestEdit";
import PageWrapper from "../../../../components/common/layout/PageWrapper";

const ARUniEntryRequestEditPage = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper centerTitle title={t("t.arUniEntryRequest.edit")}>
      <AppPageContentWrapper>
        <PageContentBox>
          <ARUniEntryRequestEdit />
        </PageContentBox>
      </AppPageContentWrapper>
    </PageWrapper>
  );
};
export default ARUniEntryRequestEditPage;
